import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

// Components
import { Text } from 'src/Components'
import ListingActionBar from 'src/Components/ListingDetails/ListingActionBar'

// Selectors
import { selectListing } from 'src/store/selectors/listings'

// Hooks
import { useFormattedListingAddress } from 'src/hooks/listings'

// Styles
import styles from './Header.module.scss'

const Address = () => {
  const listing = useSelector(selectListing)
  const addressObject = useFormattedListingAddress(listing)

  return (
    <div className={styles.address}>
      <Text variant='neutralCool' variantCount='900' size='s' weight='bold'>
        {addressObject.firstLineAddress}
      </Text>
      <Text variant='neutralCool' variantCount='700' size='s' weight='regular'>
        {addressObject.secondLineAddress}
      </Text>
    </div>
  )
}

const Header = ({ listing }) => (
  <ListingActionBar headingComponent={Address} listing={listing} />
)

Header.propTypes = {
  listing: PropTypes.object,
}

export default Header
